import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { pixel } from "@/lib/pixel";

const CONTENT_PAGES = { "/services": "Services", "/events": "Events", "/careers": "Careers" };

export function usePixel() {
  const { pathname, search } = useLocation();
  const initial = useRef(typeof window !== "undefined" ? window.location.pathname + window.location.search : "");
  const last = useRef("");
  useEffect(() => {
    if (pathname.startsWith("/admin") || pathname.startsWith("/go/")) return;
    const key = pathname + search;
    if (last.current === key) return;
    last.current = key;
    if (key !== initial.current) pixel("PageView");
    if (CONTENT_PAGES[pathname]) pixel("ViewContent", { content_name: CONTENT_PAGES[pathname], content_category: "page" });
  }, [pathname, search]);

  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest?.("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (/wa\.me|api\.whatsapp\.com|whatsapp:/i.test(href)) pixel("Contact", { content_name: "WhatsApp", content_category: a.dataset.testid || "whatsapp-link" }, { server: true });
      else if (href.startsWith("tel:")) pixel("Contact", { content_name: "Phone" }, { server: true });
      else if (href.startsWith("mailto:")) pixel("Contact", { content_name: "Email" }, { server: true });
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);
}
